import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MemberDirectoryCard from "./MemberDirectoryCard";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { fetchAllMemberDirectory } from "../../../actions/student.action";
import { filterData } from "../../../utils/helpers/dataHelper";
import TabComponent from "../../../components/TabComponent";
import { useDispatch, useSelector } from "react-redux";

export default function MemberDirectory() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [filterKey, setFilterKey] = useState("");

  useEffect(() => {
    const pageAble = { page: 0, size: 20 };
    dispatch(fetchAllMemberDirectory(pageAble));
  }, []);

  const {
    student: { memberLoading, members },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  const memberTypes = [
    { name: "B.O.T", value: "BOARD_OF_TRUSTEE" },
    { name: "Executives", value: "EXECUTIVE" },
    { name: "Chapter Lead", value: "CHAPTER_LEAD" },
  ];

  return (
    <div className="">
      <div className="doc_processing_color h-40 px-4 pt-5">
        <div className="text-md">
          <AiOutlineArrowLeft
            size={25}
            onClick={() => history.goBack()}
            className="mb-2 cursor-pointer"
          />
          <span className="text-2xl md:text-2xl text-green-800 font-serif font-bold">
            Member Directory
          </span>
        </div>
        <div className="text-md">
          Contact Information of members and leads to direct messaging
        </div>
      </div>
      <div className="p-4">
        <TabComponent
          handleFilter={(e) => setFilterKey(e)}
          data={memberTypes}
        />
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-2 mt-2 h-32">
          {filterData(members, filterKey, ["officeType"]).map((member) => {
            return (
              <MemberDirectoryCard
                imageHeight={"h-20"}
                member={member}
                key={member.id}
                textEllipse={"two_line"}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
